import type { BucketObject } from '@/entities/bucket';
import type { ResponseMeta } from '@/shared/api';
import request from '@/shared/api/request';

export const getBucketObjects = (
  name: string,
  params?: { path: string; query: string; page: number },
): Promise<{ objects: BucketObject[]; meta: ResponseMeta }> =>
  request({
    url: `/buckets/${name}/objects/`,
    params,
  });
